import React, {Component} from 'react';
import {Container, Row, Col, CardGroup, Card, CardBody, Button, Input, InputGroup, InputGroupAddon, Form} from 'reactstrap';
import {withRouter} from 'react-router';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import {Alert} from 'reactstrap';
import {logUser} from '../../../actions';
import {login} from '../../../gateways/authentication';
import {getPasswordReset, postPasswordReset} from '../../../gateways/account_management';

class Login extends Component {

  constructor(props) {
    super(props);
    this.state = {
      password: '',
      confirmPassword: '',
      showForm: true,
      alert: {
        color: 'info',
        message: ''
      }
    }
  }

  clearError() {
    return new Promise(() => { 
      this.setState({ 
        alert: {
          color: "",
          message: ""
        } 
      });
    });
  }

  submitResetPassword() {
    const token = this.props.match.params.token;
    const { password, confirmPassword } = this.state;
    postPasswordReset(password, confirmPassword, token)
    .then((result) => {
      let msg = "";
      if ( Array.isArray(result.msg) ) {
        msg = result.msg.map(m => m.msg).join(" ");
      } else if (typeof result.msg === 'string') {
        msg = result.msg;
      } else {
        msg = "Something went wrong. Please contact administrator.";
      }
      if ( result.error ) {
        this.setState({
          showForm: true,
          alert: {
            "color": "danger",
            "message": msg
          }
        });
      } else {
        this.setState({
          showForm: false,
          alert: {
            "message": result.msg
          }
        });
      }
    })
    .catch(( error ) => {
      let message = "";
      if ( error.response && error.response.data ) {
        message = error.response.data.message;
      } else {
        message = error.message;
      }
      this.setState({ alert: { color: "danger", message: message }});
    });
  }

  componentDidMount() {
    const token = this.props.match.params.token;
    getPasswordReset(token).then((result) => { 
      if ( !result.error ) {
        this.setState({
          showForm: true
        });
      } else {
        this.setState({
          showForm: false,
          alert: {
            "message": result.msg
          }
        });
      }
    })
    .catch(( error ) => {
      let message = "";
      if ( error.response && error.response.data ) {
        message = error.response.data.message;
      } else {
        message = error.message;
      }
      this.setState({ alert: { color: "danger", message: message }});
    });
  }

  onDismiss() {
    this.clearError();
  }

  renderResetPasswordForm() {
    if ( this.state.showForm ) {
      return (
        <div className="animated fadeIn">
          <h1>Reset Password</h1>
          <p className="text-muted">Please enter new password</p>
          <Alert color={this.state.alert.color} isOpen={this.state.alert.message != ""} toggle={() => this.onDismiss()}>
            {this.state.alert.message}
          </Alert>
          <Form onSubmit={() => this.submitResetPassword()}>
            <InputGroup className="mb-3">
              <Input 
                type="password"  
                placeholder="Password" 
                onChange={event => this.setState({password: event.target.value})} />
            </InputGroup>
            <InputGroup className="mb-4">
              <Input 
                type="password" 
                placeholder="Confirm Password" 
                onChange={event => this.setState({confirmPassword: event.target.value})} />
            </InputGroup>
            <Row>
              <Col xs="6">
                <Button color="primary" className="px-4" type="submit">Submit</Button>
              </Col>
            </Row>
          </Form>
        </div>
      );
    } else {
      return (
        <div className="animated fadeIn">
          <h1>Reset Password</h1>
          {this.state.alert.message} <Link to="/login">Go to Login.</Link>
        </div>
      );
    }
  }

  render() {
    return (
      <div className="app flex-row align-items-center">
        <Container>
          <Row className="justify-content-center">
            <Col xs="12" md="8">
              <Card style={{display: "block", "text-align": "center" }}>
                <img src="./img/logo_login.jpg" style={{ maxWidth: "100%" }}/>
              </Card>
            </Col>
            <Col xs="12" md="8">
              <CardGroup>
                <Card className="p-4">
                  <CardBody>
                    {this.renderResetPasswordForm()}
                  </CardBody>
                </Card>
              </CardGroup>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default withRouter(connect(null, { logUser })(Login));



// WEBPACK FOOTER //
// ./src/views/Pages/ResetPassword/ResetPassword.js